import React from "react";
import { getDiscountPercentage, getFinalPrice } from "../utils/pricing";

export default function PriceDisplay({
  item,
  currency = "EGP",
  className = "",
  showBadge = true,
  layout = "inline",
}) {
  const discount = getDiscountPercentage(item);
  const finalPrice = getFinalPrice(item);

  if (layout === "course") {
    return (
      <span className={`flex flex-col items-start gap-0.5 leading-tight ${className}`}>
        {discount > 0 && finalPrice > 0 && (
          <del className="text-sm font-medium text-slate-400 decoration-1">{Number(item.price).toFixed(2)} {currency}</del>
        )}
        <span className={`text-xl font-extrabold tracking-tight ${finalPrice === 0 ? "text-amber-700 dark:text-amber-300" : discount > 0 ? "text-[#ed1747] dark:text-rose-300" : "text-slate-900 dark:text-slate-100"}`}>
          {finalPrice === 0 ? "Free" : `${finalPrice.toFixed(2)} ${currency}`}
        </span>
      </span>
    );
  }

  if (finalPrice === 0) return <span className={className}>FREE</span>;

  return (
    <span className={`inline-flex flex-wrap items-center justify-center gap-2 ${className}`}>
      {discount > 0 && (
        <>
          <span className="text-gray-400 line-through">{Number(item.price).toFixed(2)}</span>
          {showBadge && (
            <span className="rounded-full bg-red-100 px-2 py-0.5 text-xs font-bold text-red-600">-{discount}%</span>
          )}
        </>
      )}
      <span className={discount > 0 ? "font-bold text-emerald-600" : ""}>
        {finalPrice.toFixed(2)} {currency}
      </span>
    </span>
  );
}
